export default "__VITE_ASSET__D7jL1uzk__"